import { h, Component } from 'preact'
import { connect } from 'react-redux'
import reduce from '../reducers'
import * as actions from '../actions'
import util from '../util'
import constants from '../constants'
import { CustomPicker } from 'react-color';
import EditTemplateColorsModal from "./EditTemplateColorsModal";
import designService from '../service/designService'

const { Saturation, EditableInput, Hue } = require('react-color/lib/components/common');
const tinycolor = require("tinycolor2");
const basePointerStyles = "width: 17px; height: 17px; margin-top: -1px; border-radius: 50%; border: 2px solid white; box-shadow: 0px 0px 2px black;";
const inputStyles = {
    input: {
        border: '1px solid #777777B3',
        borderRadius: '6px',
        height: '36px'
    }
};
const noGradientTypes = [constants.pickerTypes.textFont, 
    constants.pickerTypes.textLine,
    constants.pickerTypes.shapeLine, 
    constants.pickerTypes.imageBorder, 
    constants.pickerTypes.frameBorder,
    constants.pickerTypes.qrBorder,
    constants.pickerTypes.moBorder,
    constants.pickerTypes.illustrationSwatch,
    constants.pickerTypes.moFont,
    constants.pickerTypes.moIconFill,
    constants.pickerTypes.moNameFont,
    constants.pickerTypes.moNotesFont,
    constants.pickerTypes.moNameLine,
    constants.pickerTypes.moNotesLine,
    constants.pickerTypes.highlightBorder,
    constants.pickerTypes.highlightFill,
    constants.pickerTypes.textShadow,
];

const noFillTypes = [constants.pickerTypes.moFill,
    constants.pickerTypes.textFill,
    constants.pickerTypes.shapeFill,
    constants.pickerTypes.shapeLine,
    constants.pickerTypes.moNameFill,
    constants.pickerTypes.highlightFill
];

class CustomColorPicker extends Component {
    constructor() {
        super()

        this.state = {
            mode: 'solid',
            activeColor: 'primary',
            colorPrimary: '',
            colorSecondary: '',

            hsl: {
                h: 0,
                s: 0,
                l: 0
            },
            hsv: {
                h: 0,
                s: 0,
                v: 0
            },
            hex: '#ffffff',

            isEditTemplateColorsModal: false,
        }

        this.handleSaturationChange = (ev) => {
            if (this.state.mode === 'no-fill') {
                this.setState({ mode: 'solid' });
            }

            const tc = tinycolor(ev);
            const hexString = '#' + tc.toHex();

            if (ev.s === 0 || hexString === '#000000') {
                let hsl = tc.toHsl();
                hsl.h = ev.h;
                let hsv = tc.toHsv();
                hsv.h = ev.h;
                if (hexString === '#000000') {
                    hsl.s = ev.s;
                    hsv.s = ev.s;
                }
                this.setState({ hsl: hsl, hsv: hsv, hex: hexString });
            } else {
                this.setState({ hsl: tc.toHsl(), hsv: tc.toHsv(), hex: hexString });
            }
            if (this.state.activeColor === 'primary') {
                this.setState({ colorPrimary: hexString });
            } else {
                this.setState({ colorSecondary: hexString });
            }
            util.nextTick(() => {this.props.handleChange({mode: this.state.mode, colors: [this.state.colorPrimary, this.state.colorSecondary]})});
        }

        this.handleHueChange = (ev) => {
            if (this.state.mode === 'no-fill') {
                this.setState({ mode: 'solid' });
            }

            const tc = tinycolor(ev);
            const hexString = '#' + tc.toHex();

            this.setState({ hsl: ev, hsv: tc.toHsv(), hex: hexString });
            if (this.state.activeColor === 'primary') {
                this.setState({ colorPrimary: hexString });
            } else {
                this.setState({ colorSecondary: hexString });
            }
            util.nextTick(() => {this.props.handleChange({mode: this.state.mode, colors: [this.state.colorPrimary, this.state.colorSecondary]})});
        }

        this.handleInputChange = (ev) => {
            if (this.state.mode === 'no-fill') {
                this.setState({ mode: 'solid' });
            }

            const hexCode = ev.substring(1);
            this.setColorFromHex(hexCode);
        }

        this.handleBrandSwatchSelect = (hex) => {
            if (this.state.mode === 'no-fill') {
                this.setState({ mode: 'solid' });
            }

            this.setColorFromHex(hex);
        }

        this.handleDesignSwatchSelect = (color) => {
            if (this.state.mode === 'no-fill') {
                this.setState({ mode: 'solid' });
            }

            let colorData = this.getColorDataFromDesignColor(color);
            if (colorData.mode === 'solid') {
                this.setColorFromHex(colorData.colors[0]);
            } else {
                let tcColorPrimary = tinycolor(colorData.colors[0]);
                let tcColorSecondary = tinycolor(colorData.colors[1]);
                this.setState({ 
                    mode: colorData.mode, 
                    hsv: tcColorPrimary.toHsv(), 
                    hsl: tcColorPrimary.toHsl(), 
                    hex: '#' + tcColorPrimary.toHex(),
                    activeColor: 'primary',
                    colorPrimary: '#' + tcColorPrimary.toHex(),
                    colorSecondary: '#' + tcColorSecondary.toHex()
                });
                util.nextTick(() => {this.props.handleChange({mode: this.state.mode, colors: [this.state.colorPrimary, this.state.colorSecondary]})});
            }
        }

        this.setColorFromHex = (hexCode) => {
            const tc = tinycolor(hexCode);
            const hexString = '#' + tc.toHex();

            if (tc.getFormat() === 'hex') {
                this.setState({ hex: hexString, hsl: tc.toHsl(), hsv: tc.toHsv() });
                if (this.state.activeColor === 'primary') {
                    this.setState({ colorPrimary: hexString });
                } else {
                    this.setState({ colorSecondary: hexString });
                }
                util.nextTick(() => {this.props.handleChange({mode: this.state.mode, colors: [this.state.colorPrimary, this.state.colorSecondary]})});
            }
        }

        this.getHueAsHex = () => {
            let color = tinycolor({h: this.state.hsl.h, s: 1, v: 1});
            return '#' + color.toHex();
        }

        this.setActiveColor = (str) => {
            let tc = str === 'primary' ? tinycolor(this.state.colorPrimary.substring(1)) : tinycolor(this.state.colorSecondary.substring(1));
            let hexString = str === 'primary' ? this.state.colorPrimary : this.state.colorSecondary;
            this.setState({ hsl: tc.toHsl(), hsv: tc.toHsv(), hex: hexString, activeColor: str });
        }

        this.setMode = (str) => {
            this.setState({ mode: str });
            if (str === 'solid' || str === 'no-fill') {
                this.setActiveColor('primary');
            }
            util.nextTick(() => {
                if (str === 'no-fill') {
                    this.setColorFromHex('#ffffff');
                } else {
                    this.props.handleChange({mode: this.state.mode, colors: [this.state.colorPrimary, this.state.colorSecondary]})
                }
            });
        }

        this.updateOgColor = () => {
            const ogColorData = this.props.ogColorData;

            if (ogColorData) {
                let tcColorPrimary = tinycolor(ogColorData.colors[0]);
                let tcColorSecondary = tinycolor(ogColorData.colors[1]);

                this.setState({ 
                    mode: ogColorData.mode, 
                    hsv: tcColorPrimary.toHsv(), 
                    hsl: tcColorPrimary.toHsl(), 
                    hex: '#' + tcColorPrimary.toHex(),
                    activeColor: 'primary',
                    colorPrimary: '#' + tcColorPrimary.toHex(),
                    colorSecondary: '#' + tcColorSecondary.toHex()
                });
            }
        }

        this.onEditTemplateColors = () => {
            this.setState({ isEditTemplateColorsModal: true });
        }

        this.onEditTemplateColorsModalClose = () => {
            this.setState({ isEditTemplateColorsModal: false });
        }

        this.onColorsChange = (colors) => {
            this.storeDesignColors(colors);
            this.setState({ isEditTemplateColorsModal: false });
        }

        this.storeDesignColors = (colors) => {
            let colorString = colors.join(',');
            designService.updateDesignColors({
                id: this.props.designId,
                colors: colorString
            });

            this.props.updateDesignColors(colors);
        }

        this.addDesignColor = (mode, colorPrimary, colorSecondary) => {
            let colorString = '';
            if (mode === 'solid') {
                colorString += colorPrimary;
            } else if (mode === 'gradient-vertical') {
                colorString += `gv-${colorPrimary}-${colorSecondary}`;
            } else if (mode === 'gradient-horizontal') {
                colorString += `gh-${colorPrimary}-${colorSecondary}`;
            } else {
                colorString += `gr-${colorPrimary}-${colorSecondary}`;
            }
            let colorList = this.props.designColors;

            if (!colorList.includes(colorString)) {
                colorList.push(colorString);
                this.storeDesignColors(colorList);
            }
        }

        this.getDesignColorBg = (color) => {
            if (color.indexOf('gl') > -1 || color.indexOf('gv') > -1 || color.indexOf('gh') > -1 || color.indexOf('gr') > -1) {
                let colorData = this.getColorDataFromDesignColor(color);
                return util.getCssFromColorData(JSON.stringify(colorData));
            } else {
                return color;
            }
        }

        this.getColorDataFromDesignColor = (color) => {
            let colorData = '';
            if (color.indexOf('gl') > -1 || color.indexOf('gv') > -1) {
                let data = color.split('-');
                colorData = {mode: 'gradient-vertical', colors: [data[1], data[2]]};
            } else if (color.indexOf('gh') > -1) {
                let data = color.split('-');
                colorData = {mode: 'gradient-horizontal', colors: [data[1], data[2]]};
            } else if (color.indexOf('gr') > -1) {
                let data = color.split('-');
                colorData = {mode: 'gradient-radial', colors: [data[1], data[2]]};
            } else {
                colorData = {mode: 'solid', colors: [color, '#fff']};
            }
            return colorData;
        }

        this.isDesignColorGradient = (color) => {
            return (color.indexOf('gl') > -1 || color.indexOf('gv') > -1 || color.indexOf('gh') > -1 || color.indexOf('gr') > -1);
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.ogColorData !== this.props.ogColorData) {
            this.updateOgColor();
            this.addDesignColor(this.state.mode, this.state.colorPrimary, this.state.colorSecondary)
        }
    }

    componentDidMount() {
        this.updateOgColor();
    }

    componentWillUnmount() {
        this.addDesignColor(this.state.mode, this.state.colorPrimary, this.state.colorSecondary);
    }

    openEyedropper() {
        if (!window.EyeDropper) {
          console.log('Your browser does not support the EyeDropper API');
          return;
        }
    
        const eyeDropper = new EyeDropper();
    
        eyeDropper.open().then(result => {
            const hexString = result.sRGBHex;
            const hexCode = hexString.substring(1);
            const tc = tinycolor(hexCode);
            this.setState({ hsl: tc.toHsl(), hsv: tc.toHsv(), hex: hexString });
            if (this.state.activeColor === 'primary') {
                this.setState({ colorPrimary: hexString });
            } else {
                this.setState({ colorSecondary: hexString });
            }
            util.nextTick(() => {this.props.handleChange({mode: this.state.mode, colors: [this.state.colorPrimary, this.state.colorSecondary]})});
        }).catch(e => {
          console.log("eyedropper error ", e);
        });
    }

    render(props, state) {
        const SaturationPointer = () => {
            return (
              <div class="hue-sat-pointer" style={`${basePointerStyles}
              transform: translate(-8px, -8px);
              background-color: ${state.hex}`} />
            )
        }
        const HuePointer = () => {
            return (
                <div class="hue-sat-pointer" style={`${basePointerStyles}
                transform: translate(-8px, -1px);
                background-color: ${this.getHueAsHex()}`} />
            )
        }

        const isGradientType = !(noGradientTypes.includes(props.pickerType) || noGradientTypes.includes(props.pickerType[0]));
        const isNoFillType = noFillTypes.includes(props.pickerType) || noFillTypes.includes(props.pickerType[0]);

        const designColors = props.designColors.map(color => {
            return (<div class={'color-swatch' + (!isGradientType && this.isDesignColorGradient(color) ? ' hidden' : '')}
                style={`background: ${this.getDesignColorBg(color)}`}
                onClick={() => this.handleDesignSwatchSelect(color)}>
            </div>)
        })

        const brandColors = props.brandColors.map(color => {
            return (<div class="color-swatch" 
                style={`background: ${color.colorCode}`} 
                onClick={() => this.handleBrandSwatchSelect(color.colorCode)}>
            </div>)
        })

        return (
        <div id="app-aside-custom-color-picker" class={!isGradientType && !isNoFillType ? ' no-color-type' : ''}>
            <div class="scroller">
                <div class="color-type">
                    <span>Color Type</span>
                    <div class="type-swatches">
                        <div class={state.mode === 'no-fill' ? 'selected' : '' + (noFillTypes.includes(props.pickerType) || noFillTypes.includes(props.pickerType[0]) ? '' : ' hidden')} onClick={() => this.setMode('no-fill')}>
                            <div class="no-fill"></div>
                        </div>
                        <div class={state.mode === 'solid' ? 'selected' : ''} onClick={() => this.setMode('solid')}>
                            <div class="solid"></div>
                        </div>
                        <div class={state.mode === 'gradient-horizontal' ? 'selected' : '' + (isGradientType ? '' : ' hidden')} onClick={() => this.setMode('gradient-horizontal')}>
                            <div class="hor-grad"></div>
                        </div>
                        <div class={state.mode === 'gradient-vertical' ? 'selected' : '' + (isGradientType ? '' : ' hidden')} onClick={() => this.setMode('gradient-vertical')}>
                            <div class="ver-grad"></div>
                        </div>
                        <div class={state.mode === 'gradient-radial' ? 'selected' : '' + (isGradientType ? '' : ' hidden')} onClick={() => this.setMode('gradient-radial')}>
                            <div class="rad-grad"></div>
                        </div>
                    </div>
                </div>
                <div class="saturation-block">
                    <Saturation 
                        hsl={state.hsl}
                        hsv={state.hsv}
                        onChange={ (ev) => this.handleSaturationChange(ev) }
                        pointer={ SaturationPointer }
                    />
                </div>
                <div class="hue-block">
                    <Hue
                        hsl={state.hsl}
                        onChange={ (ev) => this.handleHueChange(ev) }
                        pointer={ HuePointer }
                    />
                </div>
                <div class="input-block input-one" onClick={() => this.setActiveColor('primary')}>
                    <div class="swatch" style={`background-color: ${state.colorPrimary}`}></div>
                    <EditableInput
                        value={ state.colorPrimary }
                        onChange={ (ev) => this.handleInputChange(ev) } 
                        style={inputStyles}
                    />
                    <a onClick={() => this.openEyedropper()} className={util.isSafari() || util.isFirefox() || props.isMobileVersion ? "hidden" : "eyedropper-container"}>
                    <svg><use xlinkHref={constants.appPrefix + "/svg/icons.svg#eyedropper-icon"} /></svg>
                    </a>
                </div>
                <div class={'input-block input-two' + (state.mode === 'solid' || state.mode === 'no-fill' ? ' hidden' : '')} onClick={() => this.setActiveColor('secondary')}>
                    <div class="swatch" style={`background-color: ${state.colorSecondary}`}></div>
                    <EditableInput 
                        value={ state.colorSecondary }
                        onChange={ (ev) => this.handleInputChange(ev) } 
                        style={inputStyles}
                    />
                    <a onClick={() => this.openEyedropper()} className={util.isSafari() || util.isFirefox() || props.isMobileVersion ? "hidden" : "eyedropper-container"}>
                    <svg><use xlinkHref={constants.appPrefix + "/svg/icons.svg#eyedropper-icon"} /></svg>
                    </a>
                </div>
                <div class={'design-block' + (props.designColors.length < 1 ? ' hidden' : '')}>
                    <div class="section-label">Template Colors</div>
                    {(props.isDesigner || props.isAdmin) && <button className={'edit-template'} onClick={this.onEditTemplateColors}>Edit</button>}
                    <div class="swatches">
                        {designColors}
                    </div>
                </div>
                <div class={'brand-block' + (props.brandColors.length < 1 ? ' hidden' : '')}>
                    <div class="section-label">Brand Colors</div>
                    <div class="swatches">
                        {brandColors}
                    </div>
                </div>
            </div>
            <EditTemplateColorsModal open={state.isEditTemplateColorsModal} onClose={this.onEditTemplateColorsModalClose} colors={props.designColors} onColorsChange={this.onColorsChange} getDesignColorBg={this.getDesignColorBg} />
        </div>);
    }
}

export default CustomPicker(CustomColorPicker);